// Singleton Supabase client to avoid multiple instances warning
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { projectId, publicAnonKey } from './info';

// Detect if running locally
const isLocal = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const supabaseUrl = isLocal 
  ? 'http://127.0.0.1:54321'
  : `https://${projectId}.supabase.co`;

let supabaseInstance: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient {
  if (!supabaseInstance) {
    supabaseInstance = createClient(
      supabaseUrl,
      publicAnonKey
    );
  }
  return supabaseInstance;
}

// For backwards compatibility
export const supabase = getSupabaseClient();